import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropertyCard from './PropertyCard';

const Properties = ({ properties }) => {
    const navigate = useNavigate();

    if (properties.length === 0) {
        return (
            <section id="properties" className="properties">
                <div className="container">
                    <div className="section-header">
                        <h2>Featured Properties</h2>
                        <p>Explore our handpicked selection of premium properties</p>
                    </div>
                    <div className="properties-grid">
                        <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '3rem' }}>
                            <i className="fas fa-search" style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem' }}></i>
                            <h3 style={{ color: '#666' }}>No properties found</h3>
                            <p style={{ color: '#999' }}>Try adjusting your search criteria</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section id="properties" className="properties">
            <div className="container">
                <div className="section-header">
                    <h2>Featured Properties</h2>
                    <p>Explore our handpicked selection of premium properties</p>
                </div>
                <div className="properties-grid">
                    {properties.slice(0, 6).map(property => (
                        <PropertyCard key={property.id} property={property} />
                    ))}
                </div>
                <div className="see-all-container">
                    <button 
                        onClick={() => navigate('/properties')} 
                        className="see-all-btn"
                    >
                        See All Properties {properties.length > 6 && `(${properties.length})`}
                        <i className="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Properties;
